
import { styled } from '@mui/material/styles';
import MuiTableCell from '@mui/material/TableCell';
import EDBox from '../../EDBox/EDBox';

export const EDStickyTableStickyCell: React.FC<
  React.PropsWithChildren
> = props => (
  <StyledTableCell>
    <StyledBox>{props.children}</StyledBox>
  </StyledTableCell>
);

const StyledTableCell = styled(MuiTableCell, { name: 'StickyTableStickyCell' })(
  ({ theme }) => ({
    width: 'var(--first-col-width)',
    boxSizing: 'border-box',
    padding: 0,
    border: 0,
    position: 'var(--first-col-position)' as React.CSSProperties['position'],
    left: 0,
    zIndex: 7,
    backgroundColor: `var(--first-col-background, ${theme.palette.background.paper})`,
  })
);

const StyledBox = styled(EDBox, { name: 'StickyTableStickyCellContent' })(
  ({ theme }) => ({
    position: 'absolute',
    left: 0,
    top: 0,
    right: 0,
    bottom: 0,
    padding: 'var(--first-col-padding, 0)',
    overflow:
      'var(--first-col-overflow, hidden)' as React.CSSProperties['overflow'],
    borderRight: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    borderBottom: `1px solid ${theme.customProperties.DataGrid.gridBorderColor}`,
    display: 'flex',
    flexDirection:
      'var(--first-col-direction, column)' as React.CSSProperties['flexDirection'],
    justifyContent: 'var(--first-col-alignment, center)',
    alignItems: 'var(--first-col-verticalAlignment, center)',
    textAlign:
      'var(--first-col-textAlignment, center)' as React.CSSProperties['textAlign'],
  })
);
